import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainPage from '../components/MainPage';
import { ActionTypes as Type } from '../actions/actionLog';
import getOperators from '../actions/api/operators/getOperators';
import getGroups from '../actions/api/group/getGroups';
import { ROLE } from '../lib/constants';

/**
 * アクティビティログ画面のコンテナコンポーネント。
 * ユーザーがログインしていない場合はログインページにリダイレクトする。
 *
 * @returns {React.Component} アクティビティログ画面のReactコンポーネント。
 */
const ActionLogContainer = () => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const isLogin = useSelector(state => state.main.isLogin);
  const groups = useSelector(state => state.actionLog.groups);
  const currentUserRole = useSelector(state => state.main.innerRole);
  const userInfo = useSelector(state => state.main.userInfo);

  useEffect(() => {
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'OPEN_ACTION_LOG' });
    dispatch({ type: Type.INIT_SEARCH_DATE });
    dispatch(getGroups(apiToken, {}, Type.SUCCESS_API_GET_GROUPS));

    if (groups.length > 0) {
      const groupIds = groups.map(group => group.id);
      dispatch(
        getOperators(apiToken, { groupIds }, Type.SUCCESS_API_GET_OPERATORS),
      );
    }

    if (currentUserRole === ROLE.GUEST) {
      dispatch({
        type: Type.UPDATE_SEARCH_OPERATOR,
        operatorId: userInfo?.operatorId,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiToken, dispatch, groups.length]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <MainPage />;
};

export default ActionLogContainer;
